<!--
* @Author: Kevin
* @Date: 2026-02-27 13:39:20
* @Description: CustomerService
-->

<template>
    <div class="CustomerService">
        <a href="https://work.weixin.qq.com/kfid/kfc9cf7803125222a78" target="_blank" rel="noopener noreferrer">
            <img src="https://yike33.oss-cn-beijing.aliyuncs.com/0t0y1fnozp6qt4nq8td7.png" alt="">
            <div class="text">联系客服</div>
        </a>
    </div>
</template>
<script>
export default {
    name: 'CustomerService',
    props: [],
    components: {},
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.CustomerService{
    position: fixed;
    right: 20px;
    bottom: calc(50% - 30px);
    z-index: 999;
    img{
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin: 0 auto 5px;
    }
}
</style>
